const config = {
  serverName: "LAVA",
  serverIP: "mc.lavaserver.net",
  discordInvite: "https://discord.gg/lavaserver",
  theme: {
    primaryColor: "#FF0C0A",
    secondaryColor: "#f03c3c",
    accentColor: "#ff0000",
    darkColor: "#121212",
    backgroundImage: "/images/background.jpg"
  },
  navigation: [
    { name: "Home", path: "/" },
    { name: "Rules", path: "/rules" },
    { name: "Store", path: "/store" },
    { name: "Staff", path: "/staff" },
    { name: "Vote", path: "/vote" },
    { name: "FAQ", path: "/faq" }
  ],
  externalLinks: [
    { name: "Discord", url: "https://discord.gg/lavaserver" }
  ],
  socialLinks: [
    { name: "Discord", url: "https://discord.gg/lavaserver", icon: "faDiscord" },
    { name: "YouTube", url: "https://youtube.com/lavaserver", icon: "faYoutube" },
    { name: "Twitter", url: "https://twitter.com/lavaserver", icon: "faTwitter" },
    { name: "Instagram", url: "https://instagram.com/lavaserver", icon: "faInstagram" },
    { name: "TikTok", url: "https://tiktok.com/@lavaserver", icon: "faTiktok" }
  ]
};

export default config;